import { Injectable } from '@angular/core';
import { AddAddressContent } from '@com-delta-idp/mnx-login-ui';
import {
  AddressLinesResponse,
  CountryListResponse,
  ValidateAddressRequest
} from '../../models/add-address.interface';
import { LoginModalContent } from '../../models/aem';
import { AddAddressHelperService } from '../../services/add-address/add-address-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AddAddressAdapterService {
  constructor(public helper: AddAddressHelperService) {}

  getAddAddressContent({
    ...unTransformedData
  }: {
    aemResponse: LoginModalContent;
    countryCodes: CountryListResponse;
    addressLines: AddressLinesResponse;
  }): AddAddressContent {
    return {
      formGroup: this.helper.createForm(),
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getPageContent(unTransformedData),
      isSuccess: false,
      hasError: false,
      errorMessage: ''
    };
  }

  buildRequestObject(content: AddAddressContent): ValidateAddressRequest {
    const formGroup = content.formGroup.getRawValue();
    return {
      addressLine1: this.isValueValid(formGroup.addressLine1?.value),
      addressLine2: this.isValueValid(formGroup.addressLine2?.value),
      addressLine3: this.isValueValid(formGroup.district?.value),
      addressLine4: this.isValueValid(formGroup.city?.value),
      addressLine5: content.pageContent.addressFields.addressLine5.visible
        ? formGroup.state
        : '',
      addressLine6: this.isValueValid(formGroup.addressLine6?.value),
      addressLine7: content.pageContent.addressFields.addressLine7.visible
        ? formGroup.state?.value
        : '',
      addressLine8: formGroup.country?.value,
      addressLine9: this.isValueValid(formGroup.postalCode?.value),
      formNameSubmitted: content.pageContent.viewName
    };
  }

  isValueValid(value: string | null | undefined): string {
    return (value ?? '').trim();
  }
}
